'use client'

import Link from 'next/link'
import { Suspense } from 'react'

import { getTranslate } from '@/legacy-src/utilities/i18n'

import useAppLinks from '../hooks/useAppLinks'

type Props = {
  className?: string
  type: 'google' | 'apple'
  variant?: 'default' | 'petrol'
}

const AppButtonInner: React.FC<Props> = ({ className, type, variant = 'default' }) => {
  const { t } = getTranslate()

  const { appLinkApple, appLinkGoogle } = useAppLinks()

  return (
    <div>
      {type === 'apple' ? (
        <Link href={appLinkApple} target="_blank" rel="noopener noreferrer">
          <img
            src={`/images/svg/misc/AppStore${variant === 'petrol' ? 'Petrol' : ''}.svg`}
            alt={t('components.pageBlocks.appButtons')}
            className={className}
          />
        </Link>
      ) : (
        <Link href={appLinkGoogle} target="_blank" rel="noopener noreferrer">
          <img
            src={`/images/svg/misc/GooglePlay${variant === 'petrol' ? 'Petrol' : ''}.svg`}
            alt={t('components.pageBlocks.appButtons')}
            className={className}
          />
        </Link>
      )}
    </div>
  )
}

// component needs to be wrapped in Suspense because of useSearchParams usage
const AppButton: React.FC<Props> = (props) => (
  <Suspense>
    <AppButtonInner {...props} />
  </Suspense>
)

export default AppButton
